import { jsxs as o, jsx as l } from "react/jsx-runtime";
const t = (h) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...h,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13.425 11.06 14.5 6.19h-1.8l-1.51-3.495-1.375.595 1.25 2.9h-6.19L6.19 3.3l-1.365-.62L3.23 6.19H1.505l1.5 6.81h9.19l-.4-1.5H4.21l-.84-3.81h9.265l-.84 3.81 1.63-.44Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.755 10.495h1.5V8.73H6.25l-1.495.4v1.365ZM7.255 10.495h1.5V8.73H8.75l-1.495.4v1.365ZM9.755 10.495h1.5V8.73h-.005l-1.495.4v1.365Z"
        }
      )
    ]
  }
);
export {
  t as Shop
};
